import React, { useState, useEffect } from 'react'
import { Paper, TableBody, TableRow, TableCell, Button, TextField, IconButton,} from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import makemyStyles from "../Sharedfeatures/SharedStyles";
import PageHeader from "../Common/PageHeader";
import HeadCells from "../Common/HeadCells";
import moment from 'moment';
import { CREDITLINE_INUSE_HEADER, CREDITLINE_INUSE_SUB_HEADER } from '../../utils/pageHeadings';
import useTable from "../Sharedfeatures/useTable";
import ProgressSpinner from "../Common/ProgressSpinner";
import { PAGE_SIZE } from "../../utils/variable";
import DownloadIcon from '@mui/icons-material/Download';
import useExcelDownload from '../Sharedfeatures/useExcelDownload'
import { BsSearch } from "react-icons/bs";
import { getCreditLine, getCreditLineDataExcel } from '../../slice/creditLineInuseSlice';

const CreditLineInUse = () => {

    const [excelSheetData, setExcelSheetData] = useState([]);
    const classes = makemyStyles();
    const dispatch = useDispatch();
    const [search, setSearch] = useState("");
    const [showPageNtn, setShowPageNtn] = useState(false);

    const {creditLineInuseData, totalCount, isLoading, creditLineInuseDataExcel } = useSelector((store) => store.creditlineinuseapi);

    const { TblContainer, TblHead, TblPagination, pageNo, slNo, handleChange } = useTable(creditLineInuseData, HeadCells.creditLineInuse, totalCount);

    useEffect(() => {
        const dates = {
            searchTerm: search,
            pageNo,
        }
        dispatch(getCreditLine(dates))
        dispatch(getCreditLineDataExcel(dates));
        setShowPageNtn(true);
    }, [ pageNo, search, dispatch])

    let serialNo = PAGE_SIZE * slNo;

    const handleSearch = (value) => {
        setSearch(value)
        handleChange(null, 1)
    }
    const excelData = useExcelDownload()

    useEffect(() => {
        let excelsheetdata = []
        creditLineInuseDataExcel?.map(item => {
            excelsheetdata.push({                
                "RT/DT Code" : item.userId,
                "Name" : item.userName,
                "Sanctioned Amount" : item.sanctioned_amount,
                "Creditline In-use" : item.amount_in_use,
                "Active No.Of Tranches" : item.no_of_tranches,
            })
        })
        setExcelSheetData(excelsheetdata)
    }, [creditLineInuseDataExcel])
    return (
        <>
            <Paper className={classes.pageContent}>
                <PageHeader
                    header={CREDITLINE_INUSE_HEADER}
                    subHeader={CREDITLINE_INUSE_SUB_HEADER}
                />

                {/* <Box sx={{ height: '105px' }} /> */}
                <div style={{display:'flex', gap:'20px', alignItems:'flex-start', justifyContent:'end', flexWrap:'wrap'}} >
                    {/* <TextField
                        size="small"
                        className={classes.searchTextBar}
                        value={search}
                        onChange={(e) => handleSearch(e.target.value)}
                        id="standard-bare"
                        variant="outlined"
                        placeholder="Search Name or RT/DT Code"
                        InputLabelProps={{ shrink: false }}
                        InputProps={{
                            endAdornment: (
                                <IconButton>
                                    <BsSearch className={classes.searchIconColour} />
                                </IconButton>
                            ),
                        }}
                    /> */}
                    <div style={{display:'flex', alignItems:"center", justifyContent:'space-between', flexWrap:'wrap', gap:'20px'}}>
                        
                        <Button className={classes.excelUploadButton}
                            onClick={() => excelData.generateExcelFile(excelSheetData, 'CreditLineInuse', 'creditlineinuse.xlsx')}
                            endIcon={<DownloadIcon />}>Download Ledger
                        </Button>
                    </div>
                </div>

                <Paper className={classes.tableBoxShadow}>
                    <TblContainer>
                        <TblHead />
                        {
                            isLoading ? (
                                <TableBody>
                                    <TableRow>
                                        <TableCell
                                            colSpan={8}
                                            align="center"
                                            className={classes.tableCell}
                                        >
                                            <ProgressSpinner />
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            ) : (
                                <TableBody>
                                    {
                                        (creditLineInuseData?.length !== 0) ? (
                                            creditLineInuseData && creditLineInuseData
                                                .map((item, key) => {
                                                    key++;
                                                    serialNo++;
                                                    return (
                                                        <TableRow key={key}>
                                                            <TableCell className={classes.tableCell}>{serialNo}</TableCell>
                                                            <TableCell className={classes.tableCell}>{item.userId}</TableCell>
                                                            <TableCell className={classes.tableCell}>{item.userName}</TableCell>
                                                            <TableCell className={classes.tableCell}>{item.sanctioned_amount}</TableCell>
                                                            <TableCell className={classes.tableCell}>{item.amount_in_use}</TableCell>
                                                            <TableCell className={classes.tableCell}>{item.no_of_tranches}</TableCell>
                                                        </TableRow>
                                                    )
                                                })
                                        ) : (
                                            <TableRow>
                                                <TableCell colSpan={8} align='center'>No Data to Show</TableCell>
                                            </TableRow>
                                        )
                                    }
                                </TableBody>
                            )
                        }
                    </TblContainer>
                </Paper>
                {
                    showPageNtn ? <TblPagination /> : ''
                }
            </Paper>
        </>
    )
}
export default CreditLineInUse